import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/reply-logo-compact.png'
import _imports_1 from '@/assets/auth-big-img.svg'


const _hoisted_1 = { class: "auth__container" }
const _hoisted_2 = { class: "flex-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "auth__reply-logo",
  src: _imports_0,
  alt: "Reply200"
}, null, -1)
const _hoisted_4 = { class: "auth__form" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = {
  class: "info error",
  style: {"text-align":"left"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-center auth__decoration" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Welcome"
  })
], -1)

import { parseQuery } from '@/utils/api-utils';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { accountApi } from '@/api/account';
import VButton from '@/components/VButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmChangeEmail',
  setup(__props) {

const router = useRouter()
const error = ref("")

const toBack = () => {
  router.push("/")
}

onMounted(async() => {
  try {
    const { token } = parseQuery(window.location.search)
    if (!token) {
      error.value = "Invalid link"
      return
    }
    await accountApi.confirmChangeEmail(token as string)
    router.push("/")
  } catch(e: any) {
    error.value = e.body?.message || "Error occurred"
    console.error(e.body)
  }
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, [
          (!error.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode("Loading...")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Error occurred")
              ], 64))
        ]),
        (error.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(error.value), 1),
              _createVNode(VButton, {
                class: "mt-1",
                min: "",
                onClick: toBack
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Return to Home Page")
                ]),
                _: 1
              })
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_7
  ]))
}
}

})